import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import StatCard from "./StatCard";
const StatCardPreview = () => {
    return (_jsx(StatCard, { stat: "38%", statColor: "#0CFFC6", title: "des cyberattaques", description: "recens\u00E9es en 2025 \u00E9taient du phishing." }));
};
export default StatCardPreview;
